import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Contact from './pages/Contact';
import Work from './pages/Work';
import Header from './components/Header';
import Footer from './components/Footer';
import './styles/app.css';
import './styles/typography.css';

function AppContent() {
  return (
    <div className="app-shell">
      <Header />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<Navigate to="/o-firme" replace />} />
          <Route path="/o-firme" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/vyrobky" element={<Work />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;